import {Component, OnDestroy, OnInit} from '@angular/core';
import {ParksService} from '@app/app/shared/services/parks.service';
import {ParkInterface} from '@app/app/shared/interfaces/park.interface';
import {PaginationInterface} from '@app/app/shared/interfaces/pagiantion.interface';
import {Router, ActivatedRoute} from '@angular/router';
import {AWSService} from '@app/app/shared/services/aws.service';
import {HttpClient} from '@angular/common/http';
import {MessageService} from '@app/app/shared/services/message.service';
import {ParkModel} from '@app/app/shared/models/park.model';
import {TimerObservable} from 'rxjs/observable/TimerObservable';
import {UrlHelper} from '@app/app/shared/helpers/url.helper';
import {Subscription} from 'rxjs/Subscription';
import {AuthenticationService} from '@app/app/shared/services/authentication.service';

@Component({
  moduleId: module.id,
  templateUrl: './parks.html',
  styleUrls: ['./parks.css'],
})

export class ParksComponent implements OnInit, OnDestroy {
  public parks: ParkInterface[] = [];
  public pagination: PaginationInterface;
  public isLoading = false;
  private currentPage = 1;
  private searchQuery = '';
  private statusFilter = '';
  private sub1: Subscription;
  private sub2: Subscription;
  private sub3: Subscription;
  private sub4: Subscription;
  private sub5: Subscription;
  private sub6: Subscription;
  private sub7: Subscription;
  public isPro: boolean;

  constructor(private http: HttpClient,
              private parksService: ParksService,
              private aws: AWSService,
              private route: ActivatedRoute,
              private router: Router,
              private messageService: MessageService,
              private urlHelper: UrlHelper,
              private auth: AuthenticationService) {
    this.isPro = this.auth.isPro();
  }

  ngOnDestroy() {
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
    if (this.sub4) {
      this.sub4.unsubscribe();
    }
    if (this.sub5) {
      this.sub5.unsubscribe();
    }
    if (this.sub6) {
      this.sub6.unsubscribe();
    }
    if (this.sub7) {
      this.sub7.unsubscribe();
    }
  }

  public changePage($event) {
    const newPage = parseInt($event, 10);

    this.router.navigate([`dashboard/${newPage}`]);
  }

  private prepareUrl(): string {
    switch (this.statusFilter) {
      case 'offline':
        return `${this.urlHelper.getPrefix()}/parks?size=5&filter[provisioned]=1&page=${this.currentPage}&filter[offline]=1&filter[query]=${this.searchQuery}`;
      case 'on':
        return `${this.urlHelper.getPrefix()}/parks?size=5&filter[provisioned]=1&page=${this.currentPage}&filter[on]=on&filter[query]=${this.searchQuery}`;
      case 'off':
        return `${this.urlHelper.getPrefix()}/parks?size=5&filter[provisioned]=1&page=${this.currentPage}&filter[on]=off&filter[query]=${this.searchQuery}`;
      case 'in_alarm':
        return `${this.urlHelper.getPrefix()}/parks?size=5&filter[provisioned]=1&page=${this.currentPage}&filter[has_alarms]=1&filter[query]=${this.searchQuery}`;
    }

    return `${this.urlHelper.getPrefix()}/parks?size=5&filter[provisioned]=1&page=${this.currentPage}&filter[query]=${this.searchQuery}`;
  }

  public getParks() {
    this.isLoading = true;

    this.http.get(this.prepareUrl()).subscribe(
      (res: any) => {
        this.parks = res.data.map((park) => {
          return new ParkModel(park);
        });

        this.pagination = res.meta.pagination;

        this.isLoading = false;
      }, (err) => {
        this.isLoading = false;
        console.log(err);
      }, () => {
        this.isLoading = false;
      }
    );
  }

  public reloadParks() {
    this.http.get(this.prepareUrl()).subscribe(
      (res: any) => {
        res.data.forEach((parkData) => {
          const data = ParkModel.ser(parkData);

          this.parks.forEach(park => {
            if (park.id === parkData.id) {
              data.attributes.shadow = park.attributes.shadow;
              Object.assign(park, data);
            }
          });
        });

        this.pagination = res.meta.pagination;
      },
    );
  }

  private reloadShadow(parkShadow, parkId) {
    const data = ParkModel.ser(parkShadow);

    this.parks.forEach(park => {
      if (park.attributes.parkId === parkId) {
        Object.assign(park.attributes.shadow, data);
      }
    });
  }

  private reloadNotifications(parkNotifications, parkId) {
    const data = ParkModel.ser(parkNotifications);

    this.parks.forEach(park => {
      if (park.attributes.parkId === parkId) {
        Object.assign(park.attributes.notifications, data);
      }
    });
  }

  private isFilterValid() {
    let mustReload = false;

    this.parks.forEach((park) => {
      if (this.statusFilter === 'on' && park.attributes.shadow.splashpad.mode !== 'on') {
        mustReload = true;
      }

      if (this.statusFilter === 'off' && park.attributes.shadow.splashpad.mode !== 'off') {
        mustReload = true;
      }

      if (this.statusFilter === 'offline' && !this.isOffline(park.attributes.shadow.splashpad)) {
        mustReload = true;
      }

      if (this.statusFilter === 'in_alarm') {
        // mustReload = true;
      }
    });

    return mustReload;
  }

  public isOffline(splashpad) {
    if (!splashpad.hasOwnProperty('last_connection')) {
      return true;
    }

    if (!splashpad.hasOwnProperty('last_disconnection')) {
      return false;
    }

    return Number.parseInt(splashpad.last_connection) <= Number.parseInt(splashpad.last_disconnection);
  }

  ngOnInit() {
    this.aws.connect2().subscribe(conn => {
      conn.subscribe('$aws/things/+/shadow/update/documents', {qos: 1}, (err, granted) => {
        // console.log(err, granted);
      });

      conn.subscribe('vortex/controllers/+/notifications', {qos: 1}, (err, granted) => {
        // console.log(err, granted);
      });
    });

    this.sub5 = this.aws.shadowsObservable.subscribe((message: { shadow: any, parkId: string }) => {
      this.reloadShadow(message.shadow, message.parkId);
    });

    this.sub6 = this.aws.notificationsObservable.subscribe((message: { notifications: any, parkId: string }) => {
      this.reloadNotifications(message.notifications, message.parkId);
    });

    this.sub1 = this.route.params.subscribe((data) => {
      this.currentPage = data.page || 1;

      this.getParks();
    });

    // Run cache refresh each 60 seconds
    this.sub4 = TimerObservable.create(60000, 60000).subscribe(() => {
      this.reloadParks();
    });

    this.sub2 = this.parksService.searchObservable.subscribe(res => {
      this.searchQuery = res[0].search.toLowerCase().trim();
      this.getParks();
    });

    this.sub3 = this.messageService.getMessage().subscribe(message => {
      if (typeof(message.res) === 'string') {
        if (message.res === 'clearAll') {
          this.searchQuery = '';
          this.statusFilter = '';

          if (this.sub7) {
            this.sub7.unsubscribe();
          }
        } else {
          this.statusFilter = message.res;

          if (this.sub7) {
            this.sub7.unsubscribe();
          }

          this.sub7 = TimerObservable.create(10000, 10000).subscribe(() => {
            if (this.parks.length < 5) {
              this.reloadParks();
            } else if (!this.isFilterValid()) {
              this.reloadParks();
            }
          });
        }

        this.getParks();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/parks.component.ts